import React from "react";
import { BrowserRouter } from "react-router-dom";
import { PUBLIC_ROUTES } from "./publicRoute";
import RenderRoutes from "./RenderRoutes";

const RootRouter = () => {
  const routes = PUBLIC_ROUTES;
  return (
    <BrowserRouter basename="/unified">
      <RenderRoutes routes={routes} />
    </BrowserRouter>
  );
};
 
export default RootRouter;
